// extracted by mini-css-extract-plugin
export default {"container":"Ynfh","name":"OT2R","description":"ioSu","actions":"Q0i6","action":"MDgC","primary":"nu9Q","remove":"Zq1u"};